module.exports = __webpack_public_path__ + "media/ding-sound.35ccea3e.wav";